import { supabase } from '@/lib/supabase'

// profiles.last_active_at = meaningful engagement (chat send, Bible chapter
// opened, prayer saved, ministry-map person added, study path started, etc.)
// profiles.last_seen_at   = any session load, even idle browsing
//
// Both helpers are fire-and-forget — they never throw and never block the
// caller. Failures are silent by design; engagement tracking must never
// break a user-facing action.

export async function markEngagement(userId) {
  if (!userId) return
  try {
    await supabase
      .from('profiles')
      .update({ last_active_at: new Date().toISOString() })
      .eq('id', userId)
  } catch {
    // no-op
  }
}

export async function markSeen(userId) {
  if (!userId) return
  try {
    await supabase
      .from('profiles')
      .update({ last_seen_at: new Date().toISOString() })
      .eq('id', userId)
  } catch {
    // no-op
  }
}
